import * as _ from 'underscore';
import { Component, OnInit, ChangeDetectorRef, TemplateRef, ViewChild } from '@angular/core';
import { NotifyService } from '@app/common/notify.service';
import { TranslateService } from '@ngx-translate/core';
import { ModalConfig, ModalRef, SystemNotificationType } from '@wfm/core';
import { MergePatientService } from '../merge-patient.service';
import { ModalService } from '@core/lib/services';
import { AppConfigService } from '@app/common/app-config.service';
import { DataTransformationService } from '@app/common/data-transformation.service';
import { Subscription } from 'rxjs';
import { DateTimePipe } from '@app/common/pipes';

@Component({
  selector: 'app-confirm-patient-merge',
  templateUrl: './confirm-patient-merge.component.html',
  styleUrls: ['./confirm-patient-merge.component.scss']
})
export class ConfirmPatientMergeComponent implements OnInit {
  public source: any;
  public destination: any;
  public notificationType = SystemNotificationType.highSeverityPrimary;
  dateTimePref = {} as any;
  private uvDateTimeSubscriber: Subscription;
  public smsFailureDisplay: any;
  public smsMsgHeading: any;
  @ViewChild('patientMergeFailure') patientMergeFailure: TemplateRef<any>;
  sourceAge: any;
  destinationAge: any;

  constructor(
    public config: ModalConfig,
    private mergePatientService: MergePatientService,
    public modalRef: ModalRef,
    public notify: NotifyService,
    private translate: TranslateService,
    private appConfigService: AppConfigService,
    private cd: ChangeDetectorRef,
    private modalService: ModalService,
    private dataTransformationService: DataTransformationService,
    private dateTimePipe: DateTimePipe
  ) {}

  ngOnInit(): void {
    if (this.config && this.config.data) {
      this.source = this.config.data.source;
      this.destination = this.config.data.destination;
      this.sourceAge = this.dataTransformationService.calculateStudyAge(this.source.birthDate, Date.now());
      this.destinationAge = this.dataTransformationService.calculateStudyAge(this.destination.birthDate, Date.now());
    }
    this.dateTimePref = this.appConfigService.getDateTimePref();
    this.uvDateTimeSubscriber = this.appConfigService.getDateTimeObserver().subscribe(value => {
      this.dateTimePref = value;
      this.cd.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.uvDateTimeSubscriber.unsubscribe();
  }

  mergePatient(event: Event) {
    const examStatusMsg = this.translate.instant('mergePatient.label');
    this.mergePatientService.mergePatient(this.source, this.destination).then(
      () => {
        this.notify.success(examStatusMsg, this.translate.instant('primaryExamBanner.successHeading'));
      },
      error => {
        const res = JSON.parse(error.status);
        this.smsFailureDisplay = error.error;
        const examsInReading = 'ExamsInReading';
        if (res === 502) {
          this.smsFailureDisplay.msgheading = 'StudyManagement.error.operationFailedBySMS';
          this.modalService.openModal(this.patientMergeFailure, {
            headerContent: this.translate.instant('mergePatient.label'),
            disableHeaderCloseBtn: false,
            enableYesBtn: false,
            isDecisionModal: false
          });
        } else if (res === 500 && error.error.data && error.error.data.error === examsInReading) {
          this.notify.critical(
            this.translate.instant('StudyManagement.error.operationFailedByExamReadMode'),
            examStatusMsg
          );
        } else if (res === 501) {
          this.notify.critical(
            '<h3>' +
              this.translate.instant('studyManagement.purgeFailureTitle') +
              '</h3><div>' +
              this.translate.instant('studyManagement.patientPurgeFailureMessage') +
              '</div><br/>' +
              '<div>' +
              this.translate.instant('studyManagement.sourcePatientDetailsHeading') +
              '</div>' +
              '<ul> <li>' +
              this.translate.instant('workloadManager.listContainer.label.mrn') +
              ' : ' +
              this.smsFailureDisplay.data.patientMRN +
              '</li> <li>' +
              this.translate.instant('studyManagement.patName') +
              ' : ' +
              this.smsFailureDisplay.data.patientName +
              '</li>  <li>' +
              this.translate.instant('workloadManager.listContainer.dateOfBirthLabel') +
              ' : ' +
              this.dateTimePipe.transform(this.smsFailureDisplay.data.patientDOB, this.dateTimePref.dateFormat) +
              '</li> </ul>',
            examStatusMsg
          );
        } else {
          this.smsFailureDisplay.msgheading = 'studyManagement.commonFailureMessage';
          this.modalService.openModal(this.patientMergeFailure, {
            headerContent: this.translate.instant('mergePatient.label'),
            disableHeaderCloseBtn: false,
            enableYesBtn: false,
            isDecisionModal: false
          });
        }
      }
    );
    this.closeModal(event, false);
  }

  goBack(event: Event) {
    this.closeModal(event, true);
  }

  closeModal(evt, response?) {
    evt.stopPropagation();
    this.modalRef.close(response);
  }
}
